
import React from 'react';
import { CardHeader } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Edit, Save, X } from 'lucide-react';

interface SecurityHeaderProps {
  editing: boolean;
  onEditToggle: () => void;
  onSave: () => void;
}

export const SecurityHeader: React.FC<SecurityHeaderProps> = ({ 
  editing, 
  onEditToggle, 
  onSave 
}) => {
  return (
    <CardHeader className="pb-2 flex flex-row justify-between items-center">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Security & Access</h2>
        <p className="text-muted-foreground">
          Configure authentication, authorization, and security policies
        </p>
      </div>
      <div className="flex gap-2">
        {editing ? (
          <>
            <Button variant="outline" onClick={onEditToggle} className="gap-1">
              <X className="h-4 w-4" />
              Cancel
            </Button>
            <Button onClick={onSave} className="gap-1">
              <Save className="h-4 w-4" />
              Save Changes
            </Button>
          </>
        ) : (
          <Button variant="outline" onClick={onEditToggle} className="gap-1">
            <Edit className="h-4 w-4" />
            Edit
          </Button>
        )}
      </div>
    </CardHeader>
  );
};
